import React, { useContext, useEffect, useState } from "react";
import { networkService } from "../../../../../config/axios";
import { EditorInfoContext } from "../../../../../../utis/userInfoContext";
import { csrfToken } from "../../../../../../utis/csrfTokenUtils";

const ToolBoxFooter = ({ doc }) => {
    const { setShowToast, tagValue, setTagValue , isActionDisabled,setIsActionDisabled } = useContext(EditorInfoContext)
    const [deactivate, setDeactivate] = useState(doc?.timer_on_doc)

    const handleChange = async ({ target: { checked } }, type) => {
        let fieldName = '';
        let successMessage = '';

        if (type === 'tag') {
            setTagValue(checked)
            fieldName = 'show_tags_outside'
            successMessage = checked ? 'Page tags will be shown outside' : 'Page tags will be hidden'
        } else if (type === 'deactivate') {
            setDeactivate(checked)
            fieldName = 'timer_on_doc'
            successMessage = checked ? 'Element timers deactivated' : 'Element timers activated'
        } else if (type === 'disableActions') {
            setIsActionDisabled(checked)
            fieldName = 'disable_actions'
            successMessage = checked ? 'Element actions disabled' : 'Element actions enabled'
        }

        // Save to database for this KDF
        const payload = {
            authenticity_token: csrfToken(),
            doc: {
                [fieldName]: checked,
                user_id: doc?.user_id
            }
        }
        const res = await networkService(`kdfs/${doc?.id}.json`, 'PATCH', payload);
        setShowToast({
            showToast: true,
            toastType: res.status === 200 ? 'success' : 'danger',
            toastMessage: res.status === 200 ? successMessage : 'Failed to save preference',
        });
    }

    return (
        <>
            <div className="editorToolbox__checkboxContainer align-items-center">
                <input
                    type="checkbox"
                    id="showTags"
                    className='me-2 cursor-pointer'
                    checked={tagValue}
                    onChange={(e) => handleChange(e, 'tag')}
                />
                <label htmlFor="showTags">Show page tags outside the page</label>
            </div>

            <div className="editorToolbox__checkboxContainer align-items-center">
                <input
                    type="checkbox"
                    id="deactivateTimer"
                    className='me-2 cursor-pointer'
                    checked={deactivate}
                    onChange={(e) => handleChange(e, 'deactivate')}
                />
                <label htmlFor="deactivateTimer">Deactivate element timer</label>
            </div>

            <div className="editorToolbox__checkboxContainer align-items-center">
                <input
                    type="checkbox"
                    id="disableActions"
                    className='me-2 cursor-pointer'
                    checked={isActionDisabled}
                    onChange={(e) => handleChange(e, 'disableActions')}
                />
                <label htmlFor="disableActions">Disable Actions</label>
            </div>
        </>
    )
}
export default ToolBoxFooter;
